/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Agency } from './agency';
import { Program } from './program';


export interface UserAccount { 
    accountEnabled?: boolean;
    accountNonLocked?: boolean;
    agency?: Agency;
    createdDate?: string;
    deleted?: boolean;
    email?: string;
    firstName?: string;
    fullName?: string;
    id?: string;
    lastLockedDate?: string;
    lastModifiedById?: string;
    lastModifiedDate?: string;
    lastName?: string;
    oauthProvider?: string;
    phoneNumber?: string;
    programs?: Set<Program>;
    role?: UserAccount.RoleEnum;
    username?: string;
    version?: number;
}
export namespace UserAccount {
    export const RoleEnum = {
        RoleRootAdmin: 'ROLE_ROOT_ADMIN',
        RoleProgramAdmin: 'ROLE_PROGRAM_ADMIN',
        RoleProgramAll: 'ROLE_PROGRAM_ALL',
        RoleProgramAssigned: 'ROLE_PROGRAM_ASSIGNED'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


